import { assert, expect } from '@open-wc/testing';
import { spy } from 'sinon';
import { WritableObservableValue } from './observable-value.js';

describe('WritableObservableValue', () => {
  describe('get value', () => {
    it('returns the current value', async () => {
      const initialValue = 10;
      const observedValue = new WritableObservableValue(initialValue);
      expect(observedValue.value).to.eq(initialValue);
    });
  });

  describe('subscribe', () => {
    it('calls observer with the current value', async () => {
      const observedValue = new WritableObservableValue(1);
      const observer = spy();
      observedValue.subscribe(observer);
      assert(observer.calledWithExactly(1));
    });

    it('returns a function to unscribe', async () => {
      const observedValue = new WritableObservableValue(1);
      const observer = spy();
      const unsubscribe = observedValue.subscribe(observer);

      observedValue.value = 2;
      unsubscribe();
      observedValue.value = 3;

      assert([1, 2].every(value => observer.calledWithExactly(value)));
      assert(!observer.calledWithExactly(3));
    });
  });

  describe('set value', () => {
    it('updates the stored value', async () => {
      const observedValue = new WritableObservableValue('Initial value');
      const newValue = 'Hello, World!';
      observedValue.value = newValue;
      expect(observedValue.value).to.eq(newValue);
    });

    it('calls all observers with the new value', async () => {
      const observers = [...Array(11).keys()].map(() => spy());

      const observedValue = new WritableObservableValue('Initial value');
      observers.forEach(observer => observedValue.subscribe(observer));

      const newValue = 'Hello, World!';
      observedValue.value = newValue;

      assert(observers.every(observer => observer.calledWithExactly(newValue)));
    });
  });
});
